/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SingleTurnChatGenerationInputs } from './SingleTurnChatGenerationInputs';
import {
  SingleTurnChatGenerationInputsFromJSON,
  SingleTurnChatGenerationInputsFromJSONTyped,
  SingleTurnChatGenerationInputsToJSON,
} from './SingleTurnChatGenerationInputs';

/**
 *
 * @export
 * @interface PaginatedSingleTurnChatGenerationInputsList
 */
export interface PaginatedSingleTurnChatGenerationInputsList {
  /**
   *
   * @type {number}
   * @memberof PaginatedSingleTurnChatGenerationInputsList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedSingleTurnChatGenerationInputsList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedSingleTurnChatGenerationInputsList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<SingleTurnChatGenerationInputs>}
   * @memberof PaginatedSingleTurnChatGenerationInputsList
   */
  results: Array<SingleTurnChatGenerationInputs>;
}

/**
 * Check if a given object implements the PaginatedSingleTurnChatGenerationInputsList interface.
 */
export function instanceOfPaginatedSingleTurnChatGenerationInputsList(
  value: object,
): value is PaginatedSingleTurnChatGenerationInputsList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedSingleTurnChatGenerationInputsListFromJSON(
  json: any,
): PaginatedSingleTurnChatGenerationInputsList {
  return PaginatedSingleTurnChatGenerationInputsListFromJSONTyped(json, false);
}

export function PaginatedSingleTurnChatGenerationInputsListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedSingleTurnChatGenerationInputsList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(SingleTurnChatGenerationInputsFromJSON),
  };
}

export function PaginatedSingleTurnChatGenerationInputsListToJSON(
  value?: PaginatedSingleTurnChatGenerationInputsList | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(SingleTurnChatGenerationInputsToJSON),
  };
}
